import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Componentes from '../../../components/user/componentes';


function HomeComponentesScreen () {
    return (
        <Fragment>
            <Head titulo="Área de Componentes | Departamento de TI" />
            <Header />
            <Componentes />
            <Footer />
        </Fragment>
    );
}

export default HomeComponentesScreen;